import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isEqual } from 'lodash-es';

import RadioButton from './RadioButton';

const RadioButtonGroup = ({
  options,
  name = 'radio-button-group',
  enabled,
  className,
  onChange,
  active,
  style = {},
  textOnly = false,
}) => (
  <div
    className={cx(
      'radio-button-group d-flex align-items-baseline flex-wrap',
      {
        disabled: !enabled,
      },
      className
    )}
    style={{ ...style, opacity: enabled ? 1 : 0.5 }}
    data-testid="radio-button-group"
  >
    {options.map((opt) => (
      <RadioButton
        key={opt.id}
        name={name}
        checked={isEqual(active, opt.value)}
        textOnly={textOnly}
        onChange={onChange}
        {...opt}
      />
    ))}
  </div>
);

RadioButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]).isRequired,
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
      disabled: PropTypes.bool,
      subText: PropTypes.string,
      subElement: PropTypes.element,
      preElement: PropTypes.element,
    })
  ).isRequired,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  enabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  textOnly: PropTypes.bool,
};

export default RadioButtonGroup;
